import React from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import UserList from './UserList';
import UserDetail from './UserDetail';
import InvitationList from '../Invitation/InvitationList';
import ParentReaderAssociation from './ParentReaderAssociation';

export default class User extends React.Component {
  render() {
    return (
      <Switch>
        <Route path="/users/:userId(\d+)" component={UserDetail} />
        <Route path="/users/parent-student-association" component={ParentReaderAssociation} />
        <Route path="/users/invitations" component={InvitationList} />
        <Route exact path="/users" component={UserList} />
        <Redirect to="/users" />
      </Switch>
    );
  }
}
